"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SelectPayer = require("./SelectPayer");
Object.keys(_SelectPayer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SelectPayer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SelectPayer[key];
    }
  });
});
var _SelectPayerDesktop = require("./SelectPayerDesktop/SelectPayerDesktop");
Object.keys(_SelectPayerDesktop).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SelectPayerDesktop[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SelectPayerDesktop[key];
    }
  });
});